import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { SessionFiles } from '../../helpers/schema';

export const fileInputSchema = z.object({
  fileName: z.string().min(1),
  filePath: z.string(), // Allow empty string for root path - will be normalized to "/"
  content: z.string().optional(),
  language: z.string().optional(),
});

export const schema = z.object({
  sessionId: z.string().min(1),
  files: z.array(fileInputSchema),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  files: Selectable<SessionFiles>[];
};

export const bulkCreateFiles = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/files/bulk-create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
